/* eslint-disable react/no-unknown-property */
import React from 'react';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosIFrame.css';

function CarrosEletricosIFrame() {
  return (
    <>
      <iframe
        src="https://eletropostos.tupinambaenergia.com.br/shellrecharge"
        id="frame-eletropostos"
        name="frame-eletropostos"
        loading="lazy"
        title="Iframe Eletropostos"
      />
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosIFrame;
